import * as React from "react"
import { Helmet } from "react-helmet"
import { navigate } from "gatsby"

import Navbar  from "../components/navbar/navbar"
import Hero  from "../components/hero/hero"
import Gallery  from "../components/gallery/gallery"
import Detail  from "../components/detail/detail"

class MainView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCardNumber: this.props.selectedCardNumber,
      sort: this.props.sort || "Chronological"
    };

    this.selectCardCallback = this.selectCardCallback.bind(this);
    this.deselectCardCallback = this.deselectCardCallback.bind(this);
    this.setSortCallback = this.setSortCallback.bind(this);
  }

  selectCardCallback(cardNumber) {
    if (!this.props.selectedAddress) {
      navigate(`/card/${cardNumber}`,
        {
          state: {
            sort: this.state.sort
          }
        });
    } else {
      // if on mobile, scroll to top
      if (!window.matchMedia("only screen and (min-width: 1280px)").matches) {
        window.scrollTo(0, 0);
      }

      this.setState({selectedCardNumber: cardNumber});
    }
  }

  deselectCardCallback() {
    if (!this.props.selectedAddress) {
      navigate(`/`,
        {
          state: {
            sort: this.state.sort
          }
        });
    } else {
      this.setState({selectedCardNumber: null});
    }
  }

  setSortCallback(val) {
    this.setState({sort: val});
  }

  renderCode() {
    return <>{`[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"standard","outputs":[{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"description","outputs":[{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"target","type":"address"},{"name":"mintedAmount","type":"uint256"}],"name":"mintToken","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"ipfs_hash","outputs":[{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"desc","type":"string"}],"name":"setDescription","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"isLocked","outputs":[{"name":"","type":"bool"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"},{"name":"_extraData","type":"bytes"}],"name":"approveAndCall","outputs":[{"name":"success","type":"bool"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"type":"function"},{"constant":false,"inputs":[],"name":"lock","outputs":[],"payable":false,"type":"function"},{"inputs":[{"name":"initialSupply","type":"uint256"},{"name":"tokenName","type":"string"},{"name":"tokenSymbol","type":"string"},{"name":"tokenDescription","type":"string"},{"name":"ipfsHash","type":"string"}],"payable":false,"type":"constructor"},{"payable":false,"type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}]`}</>
  }

  render() {
    const selectedCard = this.props.allCards.nodes.find(card => card.Number === Number(this.state.selectedCardNumber));
    
    const ogTitle = "Peperium"
    const ogDescription = "Peperium, the first Pepes and first art collection on the Ethereum blockchain, minted in 2017, with an on-chain verifiable IPFS hash."
    const ogWebsite = "https://peperium.art"

    return (
      <div className="">
        <Helmet>
          <html lang="en" />
          <title>{ogTitle}</title>
          <link rel="canonical" href={ogWebsite} />
          <meta charSet="utf-8" />
          <meta name="theme-color" content="#2e9737" />
          <meta name="description" content={ogDescription} />

          <meta property="og:title" content={ogTitle} />
          <meta property="og:image" content={`${ogWebsite}/icons/icon-512x512.png`} />
          <meta property="og:url" content={ogWebsite} />
          <meta property="og:description" content={ogDescription} />
          <meta property="og:type" content="website" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content={ogTitle} />
          <meta name="twitter:title" content={ogTitle} />
          <meta name="twitter:description" content={ogDescription} />
          <meta name="twitter:image" content={`${ogWebsite}/icons/icon-512x512.png`} />
        </Helmet>

        <Navbar />

        <Hero />

        <Gallery id="cards" cards={this.props.allCards.nodes} selectedCardNumber={this.state.selectedCardNumber} selectedAddress={this.props.selectedAddress}
          sort={this.state.sort}
          selectCardCallback={this.selectCardCallback} deselectCardCallback={this.deselectCardCallback}
          setSortCallback={this.setSortCallback} />
        <Detail card={selectedCard} cards={this.props.allCards.nodes} deselectCardCallback={this.deselectCardCallback} selectedAddress={this.props.selectedAddress} />

        <section id="links" className="bg-dark text-white-50 pt-3 pb-5">
            <div className="container px-4 px-lg-5 mt-5">
                <h5>Announcements</h5>

                <ul>
                    <li><a className="text-white-50" href="https://bitcointalk.org/index.php?topic=1831254.0;all">Bitcointalk (March 17, 2017) [ANN] Peperium - fully decentralized rare pepe card gallery and exchange</a></li>
                    <li><a className="text-white-50" href="https://web.archive.org/web/20170612205603/https://forum.ethereum.org/discussion/11552/announcing-peperium-rare-pepe-and-meme-trading-on-the-ethereum-blockchain">Ethereum forum (March 18, 2017) Announcing PEPERIUM - Rare Pepe and Meme Trading on the Ethereum blockchain</a></li>
                    <li><a className="text-white-50" href="https://www.reddit.com/r/ethereum/comments/60gizc/announcing_peperium_rare_pepe_and_meme_trading_on/">Reddit (March 20, 2017) Announcing PEPERIUM - Rare Pepe and Meme Trading on the Ethereum blockchain</a></li>
                    <li><a className="text-white-50" href="https://bitcointalk.org/index.php?topic=1858910.0;all">Bitcointalk (April 07, 2017) Introducing PEPERIUM - pepe and meme market on Ethereum</a></li>
                    <li><a className="text-white-50" href="https://bitcointalk.org/index.php?topic=1859922.0;all">Bitcointalk (April 07, 2017) [ANN] [RARE] PEPERIUM - meme trading on Ethereum blockchain</a></li>
                </ul>

                <h5>Articles Peperium is mentioned in</h5>
                <ul>
                    <li><a className="text-white-50" href="https://www.michigandaily.com/arts/non-fungible-tokens-a-crypto-disaster-in-progress/">Non-fungible tokens: A crypto disaster in progress</a></li>
                    <li><a className="text-white-50" href="https://gnars.com/history-of-nfts/">The Birth of a New Discipline: The History of NFT Art</a></li>
                    <li><a className="text-white-50" href="https://nfttimeline.com/">NFT Timeline</a></li>
                    <li><a className="text-white-50" href="https://dmarket.com/blog/the-beginning-of-nft-era/">When Did NFT Start? | The Beginning of NFT Era</a></li>
                    <li><a className="text-white-50" href="https://andrewsteinwold.substack.com/p/the-history-of-non-fungible-tokens">The History of Non-Fungible Tokens (NFTs)</a></li>
                    <li><a className="text-white-50" href="https://1millionnfts.medium.com/a-brief-history-of-the-nft-and-the-market-prospects-vol-2-7db659a998fd">A brief history of the NFT and the market prospects [vol. 2]</a></li>
                    <li><a className="text-white-50" href="https://nonfungible.com/news/utility/the-history-of-nfts-on-ethereum">The History of NFTs on Ethereum</a></li>
                </ul>
            </div>
        </section>

        <section id="undeadpepe" className="bg-success text-white pt-3 pb-5">
            <div className="container px-4 px-lg-5 mt-5">
                <h5>UNDEADPEPE</h5>

                <p>
                    UNDEADPEPE "A very CONTROVERSIAL RARE" has been rejected, revised, rejected, and revised again and again.<br />
                    Destroy your XCP UNDEADPEPE and resurrect on ETH blockchain. 54 UNDEADPEPE have been resurrected at the time of this post.
                </p>

                <p>
                  The max supply of UNDEADPEPE will always be 300 across chains (Ethereum vs Counterparty). That means when an UNDEADPEPE gets destroyed on Counterparty, the circulating supply on Ethereum will increase by 1.<br />
                  The rest of the Ethereum supply will be stored in one of our wallets, so we can transfer one of those to the destroyer.<br />
                  In theory all of the Counterparty UNDEADPEPE could be destroyed, so that means we have to hold on to the rest of them, but they won't be circulating.<br />
                  There's no way back, we can't destroy an Ethereum one to mint a Counterparty one, it's "one-way".
                </p>

                <h5>How does this process work?</h5>

                <div>
                    <ol>
                        <li>
                            Destroy the asset using freewallet with a memo like this <span className="badge bg-dark">Username-xxxx or ENS</span><br />
                            <ul>
                                <li>
                                    Your username and last four of the ETH wallet where you want the have the Peperium one.
                                </li>
                                <li>
                                    Or ENS if it's short enough! (So no we know it is yours, the memo field is too short for a complete ETH address unfortunately)
                                </li>
                            </ul>
                            
                        </li>
                        <li>
                            Let me (Obi) know the xchain tx id and your ETH address (which matches the memo) once done and I'll proceed from there 👌
                        </li>
                    </ol>
                </div>
            </div>
        </section>

        <section id="technical" className="mb-5">
            <div className="container bd-content px-4 px-lg-5 mt-5">
                <h4>Technical</h4>

                <h5>RARE token</h5>

                <p>
                    When launching this project, they also created a RARE token, which was intended to buy cards with, I quote from <a target="_blank" href="assets/PeperiumWhitepaper.pdf">their whitepaper</a>:
                </p>

                <div className="bd-callout bd-callout-info">
                    <em>"The RARE token will serve as a base currency for meme creation and exchange on Ethereum. The supply will be initially 100 Million and to preserve the rarity and value of this token, beginning April 20th, 2017, there will be weekly burns of 1,000,000 RARE over a period of 79 weeks, until 21,000,000 RARE are in total circulation. RARE will be divisible to 8 decimal places, and price will be based on the supply/demand dynamics of the market."</em>
                </div>

                <div>
                    The first RARE token (R$) had a bunch of issues, which were later resolved by the legendary "bookypoobah". The new RARE token was deployed and people got airdropped the same amount of RARE.
                    You can look at <a target="_blank" href="https://github.com/bokkypoobah/RAREPeperiumToken">this Github repository</a> for more details. You can use the ABI below to query the contract details.
                    The RARE token doesn't have any utility but if you want some, reach out to Obi and he'll send you some.

                    <ul>
                        <li><a className="link-dark" target="_blank" href="https://etherscan.io/address/0x584aa8297edfcb7d8853a426bb0f5252c4af9437">R$ (RARE) 0x584aa8297edfcb7d8853a426bb0f5252c4af9437</a></li>
                        <li><a className="link-dark" target="_blank" href="https://etherscan.io/address/0x5ddab66da218fb05dfeda07f1afc4ea0738ee234">RARE (RARE) 0x5ddab66da218fb05dfeda07f1afc4ea0738ee234</a></li>
                    </ul>

                    The RARE token also has a design (a bit like PEPECASH). Here's the <a href="https://ipfs.io/ipfs/QmZXeUSnjZ2PutAr2jYyZ1usriapzjkCTcYoFcJKE8svPG">IPFS link</a> of the RARE image, which is displayed below.
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col">
                            <img className="rare-img mt-3" src="assets/ipfs/RARE.png" />
                        </div>
                    </div>
                </div>

                <h5 className="mt-5">ABI</h5>

                <p>
                    If you want to verify the on-chain IPFS hash yourself, here's the ABI that you can use.
                    You can copy the contract address from the list below and use this ABI to query the contract (for example to verify the IPFS hash). A great website to interact with contracts is <a target="_blank" href="https://www.myetherwallet.com/wallet/interact">MyEtherWallet wallet interact page</a>
                </p>
              
                <pre id="code">
                  {this.renderCode()}
                </pre>
            </div>
        </section>

        <footer className="py-5 bg-dark">
            <div className="container"><p className="m-0 text-center text-white">Brought to you by ICQPEPE and Obi</p></div>
        </footer>

        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-geWF76RCwLtnZ8qwWowPQNguL3RmwHVBC9FhGdlKrxdiJJigb/j/68SIy3Te4Bkz" crossOrigin="anonymous"></script>
      </div>
    );
  }
}

export default MainView;
